import type {TimeEntry} from '@package/shared'
import {mapEntryHours} from './mapEntryHours.ts'
import dayjs from 'dayjs'

export const mapDayHours = (timeEntries: TimeEntry[]): number => {
  const hours = timeEntries.reduce((sum, entry) => {
    return sum + mapEntryHours(dayjs(entry.start), dayjs(entry.end)) - entry.breakHours
  }, 0)

  return Math.round(hours * 10) / 10
}
